<template>
    <div id="pageDashboard" class="disableLinkEfects">
        <img src="@/images/dashboard-bg-2.jpg" alt="bg-image" class="bg-image" />
        <v-container grid-list-xl fluid>
            <v-layout row wrap>
                <v-flex sm12 class="calculateMargin">
                    <v-card
                        class="mx-2 elevation-5"
                        color="rgb(225, 225, 225, 0.5)"
                        data-aos="fade"
                        data-aos-duration="2000"
                        data-aos-once="true"
                    >
                        <v-card-text class="text-xs-center text--accent-5">
                            <h1 class="green--text">Todocolegios</h1>
                            <h3 class="text-xs-center text--accent-2 pb-3">
                                Una plataforma donde puedes gestionar todos tus procesos <br />
                                en un solo sitio
                            </h3>
                            <v-btn
                                small
                                round
                                flat
                                outline
                                color="primary"
                                style="font-size: 12px"
                                @click="$vuetify.goTo('#first', { duration: 1000, offset: 100 })"
                            >
                                Comenzar
                                <v-icon small>fa-arrow-down</v-icon>
                            </v-btn>
                        </v-card-text>
                    </v-card>
                </v-flex>

                <v-flex sm12 mb-1 id="first">
                    <v-container grid-list-xl fluid py-0>
                        <v-layout row wrap>
                            <v-flex sm8 pt-4 mt-2 px-0>
                                <v-divider
                                    data-aos="fade"
                                    data-aos-once="true"
                                    data-aos-offset="155"
                                    style="border-color: black"
                                ></v-divider>
                            </v-flex>
                            <v-flex sm4 px-1>
                                <h4 data-aos="fade" data-aos-once="true" data-aos-offset="175">
                                    Administración
                                </h4>
                            </v-flex>

                            <v-flex sm3 xs12>
                                <card-info
                                    color="green"
                                    title="Usuarios"
                                    href="user"
                                    data-aos="fade-left"
                                    data-aos-duration="1300"
                                    data-aos-once="true"
                                >
                                    <template slot="icon">
                                        <v-icon x-large>fa-user</v-icon>
                                    </template>
                                    <template slot="actions">
                                        <v-btn flat icon dark large @click="showMenu($event, 'usuario')">
                                            <v-icon large>fa-list-ol</v-icon>
                                        </v-btn>
                                    </template>
                                </card-info>
                            </v-flex>

                            <v-flex sm3 xs12>
                                <card-info
                                    color="green"
                                    title="Historiales"
                                    href="historial"
                                    data-aos="fade-left"
                                    data-aos-duration="1300"
                                    data-aos-delay="300"
                                    data-aos-once="true"
                                >
                                    <template slot="icon">
                                        <v-icon x-large>fa-archive</v-icon>
                                    </template>
                                    <template slot="actions">
                                        <v-btn flat icon dark large @click="showMenu($event, 'historial')">
                                            <v-icon large>fa-list-ol</v-icon>
                                        </v-btn>
                                    </template>
                                </card-info>
                            </v-flex>

                            <v-flex sm3 xs12>
                                <card-info
                                    color="green"
                                    title="Estadísticas"
                                    href="empleados/estadisticas"
                                    data-aos="fade-left"
                                    data-aos-duration="1300"
                                    data-aos-delay="600"
                                    data-aos-once="true"
                                >
                                    <template slot="icon">
                                        <v-icon x-large>fa-bar-chart</v-icon>
                                    </template>
                                    <template slot="actions">
                                        <v-btn flat icon dark large @click="showMenu($event, 'empleado-estadisticas')">
                                            <v-icon large>fa-list-ol</v-icon>
                                        </v-btn>
                                    </template>
                                </card-info>
                            </v-flex>

                            <!-- por ahora no se van a utilizar las tareas -->
                            <!--<v-flex sm3 xs12>
                                <card-info
                                    color="green"
                                    title="Tareas"
                                    href="user-tarea"
                                    data-aos="fade-left"
                                    data-aos-duration="1300"
                                    data-aos-delay="900"
                                    data-aos-once="true"
                                >
                                    <template slot="icon">
                                        <v-icon x-large>fa-list-ul</v-icon>
                                    </template>
                                    <template slot="actions">
                                        <v-btn flat icon dark large @click="showMenu($event, 'user-tarea')">
                                            <v-icon large>fa-list-ol</v-icon>
                                        </v-btn>
                                    </template>
                                </card-info>
                            </v-flex>-->
                        </v-layout>
                    </v-container>
                </v-flex>

                <v-flex sm12 mt-6 mb-1>
                    <v-container grid-list-xl fluid py-0>
                        <v-layout row wrap>
                            <v-flex sm8 pt-4 mt-2 px-0>
                                <v-divider
                                    data-aos="fade"
                                    data-aos-once="true"
                                    data-aos-offset="155"
                                    style="border-color: black"
                                ></v-divider>
                            </v-flex>
                            <v-flex sm4 px-1>
                                <h4 data-aos="fade" data-aos-once="true" data-aos-offset="175">
                                    Personal
                                </h4>
                            </v-flex>

                            <v-flex sm3 xs12>
                                <card-info
                                    color="green"
                                    title="Empleados"
                                    href="empleado"
                                    data-aos="fade-left"
                                    data-aos-duration="1300"
                                    data-aos-once="true"
                                >
                                    <template slot="icon">
                                        <v-icon x-large>fa-group</v-icon>
                                    </template>
                                    <template slot="actions">
                                        <v-btn flat icon dark large @click="showMenu($event, 'empleado')">
                                            <v-icon large>fa-list-ol</v-icon>
                                        </v-btn>
                                    </template>
                                </card-info>
                            </v-flex>

                            <v-flex sm3 xs12>
                                <card-info
                                    color="green"
                                    title="Asistencias"
                                    href="empleados/asistencia"
                                    data-aos="fade-left"
                                    data-aos-duration="1300"
                                    data-aos-delay="300"
                                    data-aos-once="true"
                                >
                                    <template slot="icon">
                                        <v-icon x-large>fa-check-square</v-icon>
                                    </template>
                                    <template slot="actions">
                                        <v-btn flat icon dark large @click="showMenu($event, 'asistencia')">
                                            <v-icon large>fa-list-ol</v-icon>
                                        </v-btn>
                                    </template>
                                </card-info>
                            </v-flex>

                            <v-flex sm3 xs12>
                                <card-info
                                    color="green"
                                    title="Prenóminas"
                                    href="empleados/nomina"
                                    data-aos="fade-left"
                                    data-aos-duration="1300"
                                    data-aos-delay="600"
                                    data-aos-once="true"
                                >
                                    <template slot="icon">
                                        <v-icon x-large>fa-money</v-icon>
                                    </template>
                                    <template slot="actions">
                                        <v-btn flat icon dark large @click="showMenu($event, 'nomina')">
                                            <v-icon large>fa-list-ol</v-icon>
                                        </v-btn>
                                    </template>
                                </card-info>
                            </v-flex>

                            <v-flex sm3 xs12>
                                <card-info
                                    color="green"
                                    title="Nomencladores"
                                    href="dashboard"
                                    data-aos="fade-left"
                                    data-aos-duration="1300"
                                    data-aos-delay="900"
                                    data-aos-once="true"
                                >
                                    <template slot="icon">
                                        <v-icon x-large>fa-cog</v-icon>
                                    </template>
                                    <template slot="actions">
                                        <v-btn flat icon dark large @click="showMenu($event, 'personal')">
                                            <v-icon large>fa-list-ol</v-icon>
                                        </v-btn>
                                    </template>
                                </card-info>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-flex>

                <v-flex sm12 mt-6 mb-1>
                    <v-container grid-list-xl fluid py-0>
                        <v-layout row wrap>
                            <v-flex sm8 pt-4 mt-2 px-0>
                                <v-divider
                                    data-aos="fade"
                                    data-aos-once="true"
                                    data-aos-offset="155"
                                    style="border-color: black"
                                ></v-divider>
                            </v-flex>
                            <v-flex sm4 px-1>
                                <h4 class="gray--text" data-aos="fade" data-aos-once="true" data-aos-offset="175">
                                    Finanzas
                                </h4>
                            </v-flex>

                            <v-flex sm3 xs12>
                                <card-info
                                    color="green"
                                    title="Activos"
                                    href="activo"
                                    data-aos="fade-left"
                                    data-aos-duration="1300"
                                    data-aos-once="true"
                                >
                                    <template slot="icon">
                                        <v-icon x-large>fa-pencil</v-icon>
                                    </template>
                                    <template slot="actions">
                                        <v-btn flat icon dark large @click="showMenu($event, 'activo')">
                                            <v-icon large>fa-list-ol</v-icon>
                                        </v-btn>
                                    </template>
                                </card-info>
                            </v-flex>

                            <v-flex sm3 xs12>
                                <card-info
                                    color="green"
                                    title="Solicitudes de pago"
                                    href="solicitud-pago"
                                    data-aos="fade-left"
                                    data-aos-duration="1300"
                                    data-aos-delay="300"
                                    data-aos-once="true"
                                >
                                    <template slot="icon">
                                        <v-icon x-large>fa-dollar</v-icon>
                                    </template>
                                    <template slot="actions">
                                        <v-btn flat icon dark large @click="showMenu($event, 'solicitudes-pago')">
                                            <v-icon large>fa-list-ol</v-icon>
                                        </v-btn>
                                    </template>
                                </card-info>
                            </v-flex>

                            <v-flex sm3 xs12>
                                <card-info
                                    color="green"
                                    title="Montos"
                                    href="montos"
                                    data-aos="fade-left"
                                    data-aos-duration="1300"
                                    data-aos-delay="600"
                                    data-aos-once="true"
                                >
                                    <template slot="icon">
                                        <v-icon x-large>fa-bar-chart</v-icon>
                                    </template>
                                    <template slot="actions">
                                        <v-btn flat icon dark large @click="showMenu($event, 'solicitud-pago-stats')">
                                            <v-icon large>fa-list-ol</v-icon>
                                        </v-btn>
                                    </template>
                                </card-info>
                            </v-flex>

                            <v-flex sm3 xs12>
                                <card-info
                                    color="green"
                                    title="Nomencladores"
                                    href="dashboard"
                                    data-aos="fade-left"
                                    data-aos-duration="1300"
                                    data-aos-delay="900"
                                    data-aos-once="true"
                                >
                                    <template slot="icon">
                                        <v-icon x-large>fa-cog</v-icon>
                                    </template>
                                    <template slot="actions">
                                        <v-btn flat icon dark large @click="showMenu($event, 'finanzas')">
                                            <v-icon large>fa-list-ol</v-icon>
                                        </v-btn>
                                    </template>
                                </card-info>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-flex>

                <v-flex sm12 mt-6 mb-1>
                    <v-container grid-list-xl fluid py-0>
                        <v-layout row wrap>
                            <v-flex sm8 pt-4 mt-2 px-0>
                                <v-divider
                                    data-aos="fade"
                                    data-aos-once="true"
                                    data-aos-offset="155"
                                    style="border-color: black"
                                ></v-divider>
                            </v-flex>
                            <v-flex sm4 px-1>
                                <h4 class="gray--text" data-aos="fade" data-aos-once="true" data-aos-offset="175">
                                    Cobranza
                                </h4>
                            </v-flex>

                            <v-flex sm3 xs12>
                                <card-info
                                    color="green"
                                    title="Estudiantes"
                                    href="estudiante"
                                    data-aos="fade-left"
                                    data-aos-duration="1300"
                                    data-aos-once="true"
                                >
                                    <template slot="icon">
                                        <v-icon x-large>fa-graduation-cap</v-icon>
                                    </template>
                                    <template slot="actions">
                                        <v-btn flat icon dark large @click="showMenu($event, 'estudiante')">
                                            <v-icon large>fa-list-ol</v-icon>
                                        </v-btn>
                                    </template>
                                </card-info>
                            </v-flex>

                            <v-flex sm3 xs12>
                                <card-info
                                    color="green"
                                    title="Nomencladores"
                                    href="dashboard"
                                    data-aos="fade-left"
                                    data-aos-duration="1300"
                                    data-aos-delay="300"
                                    data-aos-once="true"
                                >
                                    <template slot="icon">
                                        <v-icon x-large>fa-cog</v-icon>
                                    </template>
                                    <template slot="actions">
                                        <v-btn flat icon dark large @click="showMenu($event, 'cobranza')">
                                            <v-icon large>fa-list-ol</v-icon>
                                        </v-btn>
                                    </template>
                                </card-info>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-flex>
            </v-layout>
        </v-container>

        <v-menu
            v-model="cardActionsMenu"
            transition="scale-transition"
            :position-x="x"
            :position-y="y"
            absolute
            :close-on-content-click="false"
        >
            <card-info-actions
                v-if="!nomencladoresSectionfilter"
                :options="menuActionsFiltered"
                @closeMenu="cardActionsMenu = false"
            ></card-info-actions>
            <card-info-nomencladores
                v-else
                :options="menuNomencladoresActionsFiltered"
                @closeMenu="cardActionsMenu = false"
            ></card-info-nomencladores>
        </v-menu>
    </div>
</template>

<script>
import Util from "@/util"
import CardInfo from "@/components/widgets/card-info/CardInfo"
import CardInfoActions from "@/components/widgets/card-info-actions/card-info-actions"
import CardInfoNomencladores from "@/components/widgets/card-info-actions/card-info-nomencladores"

export default {
    components: { CardInfoNomencladores, CardInfoActions, CardInfo },
    data() {
        return {
            //menu de acciones
            cardActionsMenu: false,
            x: 0,
            y: 0,

            //acciones para los menuses
            accionesSectionfilter: "usuario",
            nomencladoresSectionfilter: null,
            acciones: Util.DashboardActions(),
            personalNomencladores: Util.PersonalNomencladores(),
            finanzasNomencladores: Util.FinanzasNomencladores(),
            cobranzaNomencladores: Util.CobranzaNomencladores()
        }
    },
    computed: {
        menuActionsFiltered() {
            return this.acciones.filter(el => el.routeName === this.accionesSectionfilter)[0]
        },

        menuNomencladoresActionsFiltered() {
            if (this.nomencladoresSectionfilter) {
                switch (this.nomencladoresSectionfilter) {
                    case "personal":
                        return this.personalNomencladores
                    case "finanzas":
                        return this.finanzasNomencladores
                    case "cobranza":
                        return this.cobranzaNomencladores
                }
            } else {
                return this.personalNomencladores
            }
        }
    },
    methods: {
        showMenu(event, sectionFilter) {
            if (sectionFilter === "personal" || sectionFilter === "finanzas" || sectionFilter === "cobranza") {
                this.nomencladoresSectionfilter = sectionFilter
            } else {
                this.accionesSectionfilter = sectionFilter
                this.nomencladoresSectionfilter = null
            }

            this.cardActionsMenu = false
            this.x = event.clientX
            this.y = event.clientY
            this.$nextTick(() => {
                this.cardActionsMenu = true
            })
            event.stopPropagation()
        }
    },
    created() {}
}
</script>

<style>
.calculateMargin {
    margin-top: calc(100vh / 2 - 155px);
    margin-bottom: calc(100vh / 2 - 155px);
}

.bg-image {
    height: 100vh;
    width: 100vw;
    position: fixed;
    opacity: 0.1;
    z-index: 0;
}
</style>
